module.exports = __webpack_public_path__ + "static/networks2-1d1284250801614add7b8a6f685aa15b.jpg";